import { SCENE_CLASSES } from '../../constants/classNames';

/**
 * A conical (Erlenmeyer) flask whose neck top sits at (x, y).
 * Shows the substance symbol on the glass, or "?" when empty.
 */
export default function ConicalFlask({ x, y, liquidColor, label }) {
  const glassPath = `M${x - 6} ${y} h12 v22 l20 40 q3 6 -4 6 h-44 q-7 0 -4 -6 l20 -40 z`;
  const liquidPath = `M${x - 15.5} ${y + 42} h31 l9.5 19 q2 5 -3 5 h-44 q-5 0 -3 -5 z`;

  return (
    <g className={SCENE_CLASSES.flask}>
      <path d={liquidPath} fill={liquidColor} />
      <path d={glassPath} fill="rgba(255,255,255,0.25)" stroke="#5b7fa8" strokeWidth="2.5" strokeLinejoin="round" />
      <rect x={x - 8} y={y - 3} width="16" height="4" rx="2" fill="#5b7fa8" />
      <text
        className={SCENE_CLASSES.flaskLabel}
        x={x}
        y={y + 60}
        textAnchor="middle"
        fontSize={label.length > 2 ? 11 : 14}
        fontWeight="700"
        fill="#1d2a3a"
      >
        {label}
      </text>
    </g>
  );
}
